import { FC, ReactNode } from 'react'
import { Dialog } from '@zoom/react-ui'
import { MappedFileTypes, StaticFileIconsConstant } from '../../constants'
import {
  useAppDispatch,
  useAppSelector,
  useSelectUnfurlLink,
} from '../../hooks'
import { App, selectApp } from '../../app/root'
import { closeDialog, selectDialog, selectDialogProps } from '../../app/dialog'
import { FileMS, selectFile } from '../../app/file'
import {
  useCreateFileGoogleMutation,
  useCreateFileMSMutation,
} from '../../app/appApiQueries'
import { IconFileFormatDocument } from '@zoom/icons-react'

type ViewDialog = {
  titleVerb: string
  children: ReactNode
  okText?: string
}

const ViewDialog: FC<ViewDialog> = ({ titleVerb, children, okText }) => {
  const dispatch = useAppDispatch()
  const unfurlLink = useSelectUnfurlLink()
  const { name, url, type } = useAppSelector(selectFile) || {}
  const dialogProps = useAppSelector(selectDialogProps)
  const dialog = useAppSelector(selectDialog)
  const app = useAppSelector(selectApp) as App
  const [createFileGoogle] = useCreateFileGoogleMutation()
  // ============================= Start V3 =============================
  // Delete the last else if to go to back to native collaboration
  const { driveId } = (useAppSelector(selectFile) as FileMS) || {}
  const [createFileMS] = useCreateFileMSMutation()
  // ============================= End V3 =============================

  let iconType = type
  let fileName = name
  let fileUrl: string | undefined = url

  if (dialog === 'collaborationNoShareNew') {
    iconType = dialogProps?.file || 'docx'
    fileName = 'New Document'
    fileUrl = undefined
  }
  if (dialog === 'noAccess') {
    fileUrl = unfurlLink
    fileName = ''
  }

  const handleClose = () => {
    dispatch(closeDialog())
  }

  const handleViewDocument = async () => {
    if (!fileUrl && fileName && iconType) {
      if (app === 'Google') {
        const data = await createFileGoogle({
          fileName,
          fileType: MappedFileTypes[iconType],
          share: false,
        }).unwrap()
        fileUrl = data.fileUrl
        // ============================= Start V3 =============================
        // Delete the last else if to go to back to native collaboration
      } else if (app === 'Microsoft') {
        const data = await createFileMS({
          fileName,
          driveId,
          fileType: MappedFileTypes[iconType],
        })

        fileUrl = data.data?.fileUrl
      }
      // ============================= End V3 =============================
    }

    if (fileUrl)
      await zoomSdk.openUrl({ url: fileUrl }).then(() => handleClose())
  }

  return (
    <Dialog
      title={
        <div className='flex gap-2'>
          <div className='flex-none'>
            {StaticFileIconsConstant[app][iconType || 'docx'] || (
              <IconFileFormatDocument color='#3B90F7' />
            )}
          </div>
          <p className='truncate font-sans'>
            {titleVerb}{' '}
            {dialog === 'collaborationNoShareNew' ? 'new document ' : fileName}
          </p>
        </div>
      }
      okText={okText || 'View document'}
      onCancel={handleClose}
      onOk={handleViewDocument}
      onEscapeKeyDown={handleClose}
      onBackdropClick={handleClose}
      closable
    >
      <div className='!text-customGray'>{children}</div>
    </Dialog>
  )
}

export default ViewDialog
